import { render, staticRenderFns } from "./ReviewOpportunity.vue?vue&type=template&id=65786a7e&scoped=true&"
import script from "./ReviewOpportunity.vue?vue&type=script&lang=js&"
export * from "./ReviewOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./ReviewOpportunity.vue?vue&type=style&index=0&id=65786a7e&prod&lang=css&"
import style1 from "./ReviewOpportunity.vue?vue&type=style&index=1&id=65786a7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65786a7e",
  null
  
)

export default component.exports